/**
 * Basis-point parsing/formatting for ownership shares (ported from n27).
 * Rates are stored as integer basis points (10000 = 100 %) — floats never
 * touch stored values.
 */

/** Parses percent input like "3,5" or "3.5" into basis points (350). Max 2 decimals. */
export function parsePercentToBps(input: string): number | null {
  const raw = input.trim().replace(/[%\s]/g, '').replace(',', '.');
  if (!raw) return null;
  if (!/^-?\d+(\.\d{1,2})?$/.test(raw)) return null;
  return Math.round(Number.parseFloat(raw) * 100);
}

/** Formats basis points for form inputs: 350 → "3.50". */
export function bpsToPercentInput(bps: number): string {
  const sign = bps < 0 ? '-' : '';
  const abs = Math.abs(bps);
  return `${sign}${Math.floor(abs / 100)}.${String(abs % 100).padStart(2, '0')}`;
}

/** Display helper: 350 → "3,50 %". */
export function formatBpsAsPercent(bps: number, locale: string = 'de-DE'): string {
  return `${new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(bps / 100)} %`;
}
